/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded and parsed');

    const productMediaItems = document.querySelectorAll('.product__slide');
    if (productMediaItems.length > 0) {
      const firstNonVariantImage = Array.from(productMediaItems).find(mediaItem => {
        console.log('Checking media item:', mediaItem);
        return !mediaItem.getAttribute('data-variant');
      });

      if (firstNonVariantImage) {
        console.log('First non-variant image found:', firstNonVariantImage);
        const firstImageId = firstNonVariantImage.getAttribute('data-media-id');
        firstNonVariantImage.dispatchEvent(
          new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: {
              id: firstImageId,
            },
          })
        );
      } else {
        console.log('No non-variant image found');
      }
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// this is an Array so starts from 0. always subtract month by 1.
function isHoliday(date) {
  const holidays = [
    new Date(2024, 0, 1), // New Year's Day
    new Date(2024, 2, 29), // Good Friday
    new Date(2024, 3, 1), // Easter Monday
    new Date(2024, 4, 6), // Early May Bank Holiday
    new Date(2024, 4, 27), // Spring Bank Holiday
    new Date(2024, 7, 26), // Summer Bank Holiday
    new Date(2024, 11, 25), // Christmas Day
    new Date(2024, 11, 26), // Boxing Day
  ];

  for (let i = 0; i < holidays.length; i++) {
    if (date.getFullYear() === holidays[i].getFullYear() &&
        date.getMonth() === holidays[i].getMonth() &&
        date.getDate() === holidays[i].getDate()) {
        return true;
    }
  }
  return false;
}

function isBusinessDay(date) {
  const dayOfWeek = date.getUTCDay();
  return dayOfWeek > 0 && dayOfWeek < 6;
}

function nextBusinessDay(date) {

  let nextDay = new Date(date);
  nextDay.setUTCDate(date.getUTCDate() + 1);

  while (!isBusinessDay(nextDay) || isHoliday(nextDay)) {
    nextDay.setUTCDate(nextDay.getUTCDate() + 1);
  }

  return nextDay;
}

function countdownToDispatch() {

  const now = new Date();
  let dispatchDate;

  //If it's before 11AM, a business day, and not a holiday, our dispatch date is today!

  if (now.getUTCHours() < 12 && isBusinessDay(now) && !isHoliday(now)) {
    dispatchDate = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 12, 0, 0, 0);
  } else {
    dispatchDate = nextBusinessDay(now);
    dispatchDate.setUTCHours(11, 0, 0, 0);
  }

  const timeUntilDispatch = dispatchDate.getTime() - now.getTime();
  const days = Math.floor(timeUntilDispatch / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeUntilDispatch % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeUntilDispatch % (1000 * 60 * 60)) / (1000 * 60));
  //const seconds = Math.floor((timeUntilDispatch % (1000 * 60)) / 1000);

  let timeString = '';

  if (days > 0) {
    timeString += days + ' days ';
  }
  if (hours > 0) {
    if (hours === 1) {
      timeString += hours + ' hour ';
    } else {
      timeString += hours + ' hours ';
    }
  }
  if (minutes > 0) {
    timeString += minutes + ' minutes ';
  }

  return timeString.trim();
}
function setOrderArrivalDate() {
  const now = new Date();

  let dispatchDate;
  if (now.getUTCHours() < 11 && isBusinessDay(now) && !isHoliday(now)) {
    dispatchDate = now;
  } else {
    dispatchDate = nextBusinessDay(now);
  }

  const arrivalDate = nextBusinessDay(dispatchDate);
  let result = countdownToDispatch();

  const formattedDate = arrivalDate.toLocaleDateString("en-GB", {
    weekday: 'long', 
    day: 'numeric',
    month: 'long'
  });

  const finalArrivalDateString = formattedDate.split(' ')[0] + ' ' + ordinalSuffix(arrivalDate.getUTCDate()) + ' ' + formattedDate.split(' ')[2];
  const deliveryText = document.getElementById('delivery-text');
  
  if(deliveryText) {
    if(deliveryText.classList.contains('alternate')) {
      deliveryText.innerHTML = 'Order within ' + result + ' for delivery by ' + finalArrivalDateString;
    } else {
      deliveryText.innerHTML = 'Order within ' + result + ' for delivery by ' + finalArrivalDateString;
    }
  }
}

function ordinalSuffix(i) {
  const j = i % 10, k = i % 100;
  if (j == 1 && k != 11) {
      return i + "st";
  }
  if (j == 2 && k != 12) {
      return i + "nd";
  }
  if (j == 3 && k != 13) {
      return i + "rd";
  }
  return i + "th";
}

setInterval(setOrderArrivalDate, 1000);